import Vue from 'vue'

import {
  Tab,
  Tabs
} from 'vant'

Vue.use(Tab)
  .use(Tabs)



// WEBPACK FOOTER //
// ./src/plugins/vant.js